/**
 * Maps lab base paths to their valid tab labels.
 * Each lab can have one or more tabs that appear in breadcrumbs.
 * The labels here are the human-readable versions used in the UI.
 */
export const LAB_TABS_MAP = {
  aidemec: ["Overview", "Life Cycle Assessment"],
  concatll: ["Overview", "Life Cycle Assessment"],
  ecoreadymasuria: ["Overview", "Life Cycle Assessment"],
  ecovitall: ["Overview", "Life Cycle Assessment"],
  esappin: ["Overview", "Life Cycle Assessment"],
  livorganic: ["Overview", "Life Cycle Assessment"],
  lofs: ["Overview", "Life Cycle Assessment"],
  probio: ["Overview", "Oats", "Life Cycle Assessment"],
  secocollab: ["Overview", "Energy", "Life Cycle Assessment"],
  thalla: ["Overview", "Life Cycle Assessment"],
};
